import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'

const EditCommentBot = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Comment Bot'
      fields={fields}
      apiPath={`admin/comment_bots/${props.params.commentBotId}`}
      successRedirectPath='/write-now/comment-bots'
    />
  )
}

export default EditCommentBot
